export const language = {
	specialCompetenciesHeading: 'Special Competencies Include:',
};
